<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import { BannerPublicResponseBannerTypEnum } from '/@src/client-public'

interface ZoppmStorybookComponentProps {
  type?: BannerPublicResponseBannerTypEnum
  text?: string | undefined | null
}

const props = withDefaults(defineProps<ZoppmStorybookComponentProps>(), {
  type: BannerPublicResponseBannerTypEnum.Warning,
  text: undefined,
})

const { t } = useI18n()
const bannerVisibility = ref<boolean>(true)

const hideBanner = () => {
  bannerVisibility.value = false
}
</script>

<template>
  <div
    v-if="typeof props?.text === 'string' && bannerVisibility"
    :class="`banner-${props.type} app-banner`"
  >
    <div class="govuk-width-container">
      <div class="govuk-grid-row">
        <div class="govuk-grid-column-full">
          <div class="govuk-body banner-text pt-4 w-100" v-html="props.text" />
          <button
            class="idsk-button idsk-button--secondary"
            type="submit"
            data-test-id="button-banner-hide"
            @click="hideBanner"
          >
            {{ t('banner.hide') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}

.banner-text {
  color: #ffffff;
  font-size: 1.2rem;
  line-height: 1.5;
  display: inline-block;
}

.banner-WARNING {
  background-color: var(--idsk-color-yellow);
  .banner-text {
    color: #000000;
  }
}

.banner-INFO {
  background-color: var(--idsk-color-lighter-grey);
  .banner-text {
    color: #000000;
  }
}

.banner-SUCCESS {
  background-color: #00703c;
}
</style>
